/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var HelpOutlineIcon = function HelpOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M12.4331 9.18827C12.1126 8.91356 11.6523 8.87475 11.2903 9.09193L10.0145 9.85743L8.98547 8.14244L10.2613 7.37695C11.3615 6.71685 12.7606 6.8348 13.7347 7.66976C15.4022 9.09906 15.0022 11.7755 13 12.6591V13.4999H11V11.9999C11 11.5999 11.2384 11.2384 11.6061 11.0808L12.1812 10.8343C12.8488 10.5482 12.9846 9.66095 12.4331 9.18827Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17V15H11V17H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
  }));
};
export default HelpOutlineIcon;